


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ReferralStatus } from '@/api/types'

@Component
export default class StatusIcon extends Vue {
    @Prop({ required: true }) readonly status!: ReferralStatus

    colorForStatus(opacity: number = 1): string {
        const colors = {
            open: `rgba(96, 96, 96, ${opacity})`,
            [ReferralStatus.NEW]: `rgba(19, 210, 197, ${opacity})`,
            [ReferralStatus.UNREACHABLE]: `rgba(235, 89, 140, ${opacity})`,
            [ReferralStatus.PENDING]: `rgba(247, 131, 35, ${opacity})`,
            [ReferralStatus.APPOINTMENT]: `rgba(66, 153, 225, ${opacity})`,
            [ReferralStatus.PROPOSAL]: `rgba(145, 105, 226, ${opacity})`,
            [ReferralStatus.ON_HOLD]: `rgba(231, 220, 30, ${opacity})`,
            [ReferralStatus.SUCCESSFUL]: `rgba(0, 163, 137, ${opacity})`,
            [ReferralStatus.CLOSED]: `rgba(222, 64, 119, ${opacity})`,
            [ReferralStatus.PROCESSED]: `rgba(169, 50, 38, ${opacity})`,
        }

        return colors[this.status]
    }

    iconColorForStatus(opacity: number = 1): string {
        const colors = {
            open: `rgba(192, 192, 192, ${opacity})`,
            [ReferralStatus.SUCCESSFUL]: `rgba(0, 163, 137, ${opacity})`,
            [ReferralStatus.CLOSED]: `rgba(222, 64, 119, ${opacity})`,
        }

        return colors[this.status]
    }
}
